<template>
  <div>
    <user-greeting
      v-if="isUserLogged"
      :section="section"
      @set-active="setActiveItem"
      @close="closeFlyout"
    />
    <button
      v-else
      class="loginButton"
      @click="setActiveItem('myBt')"
      @keyup.esc="closeFlyout"
    >
      <v-lazy-image
        :src="section.icon.source"
        :alt="section.icon.alt"
        width="24"
        height="24"
      />
      <span v-if="isDesktop">{{ section.title }}</span>
    </button>
    <template v-if="!isLoginDisabled">
      <template v-if="!isUserLogged">
        <pre-header-flyout
          v-if="preHeaderOpenItems.myBt && !isUserLogged"
          @closeFlyout="closeFlyout"
        >
          <login-form @close="closeFlyout" />
        </pre-header-flyout>
      </template>
      <template v-else>
        <pre-header-flyout
          v-if="preHeaderOpenItems.profile"
          class="profile"
          @closeFlyout="closeFlyout"
        >
          <user-profile
            :is-clean="userData.clean"
            class="manage-profile-white"
            @closeFlyout="closeFlyout"
          />
        </pre-header-flyout>
      </template>
    </template>
    <template v-else>
      <pre-header-flyout
        v-if="preHeaderOpenItems.myBt"
        class="disabled"
      >
        <close-icon @click="closeFlyout" />
        <v-alert>
          {{ $t('header.loginForm.unavailableLogin') }}
        </v-alert>
      </pre-header-flyout>
    </template>
  </div>
</template>

<script>
  import VLazyImage from 'v-lazy-image'
  import { mapGetters, mapState } from 'vuex'

  import UserProfile from 'components/LoginForm/UserProfile'
  import LoginForm from 'components/LoginForm/White/LoginForm'
  const UserGreeting = () =>
    import(
      /* webpackChunkName: "storyblok-user-greeting" */ 'components/Storyblok/Header/UserGreetng'
    )

  const PreHeaderFlyout = () =>
    import(
      /* webpackChunkName: "location-form" */ 'components/Header/White/PreHeader/PreHeaderFlyout.vue'
    )
  const VAlert = () => import(/* webpackChunkName: "v-alert" */ 'components/VAlert.vue')
  const CloseIcon = () =>
    import(/* webpackChunkName: "close-icon" */ 'components/CloseIcon.vue')

  export default {
    components: {
      VLazyImage,
      PreHeaderFlyout,
      LoginForm,
      UserProfile,
      VAlert,
      CloseIcon,
      UserGreeting
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState('main/user', ['userData', 'isUserLogged']),
      ...mapState('header', ['profileMenuLinks', 'profileMenuCleanLinks']),
      ...mapGetters('device', ['isMobile', 'isDesktop']),
      ...mapState('header', ['preHeaderOpenItems']),
      ...mapState('main', ['isLoginDisabled']),
      initials() {
        let initials = ''

        if (this.userData?.firstName) {
          initials += this.userData.firstName.charAt(0)
        }

        if (this.userData?.lastName) {
          initials += this.userData.lastName.charAt(0)
        }

        return initials
      }
    },
    methods: {
      setActiveItem(key) {
        if (this.preHeaderOpenItems[key]) {
          this.closeFlyout()
          return
        }

        this.$store.dispatch('header/openPreHeaderItem', key)
        this.$emit('show-backdrop')
      },
      closeFlyout() {
        this.$emit('close-backdrop')
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .loginButton {
    width: 40px;
    height: 40px;
    padding: 0;

    @include bp-mf-tablet {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: rem(8, 16);
    }

    @include bp-mf-desktop {
      padding: 8px 16px;
      background: $green-base;
      color: $blue-dark;
      border-radius: 4px;
      height: 40px;
      width: auto;

      &:hover {
        background: $green-hover-light;
      }
    }

    + .pre-header-flyout {
      top: 40px;
      left: auto;
      right: 0;
    }
  }

  ::v-deep .manage-profile-white {
    z-index: 5;
    left: calc(50% - 14px);
    top: 43px;

    @include bp-mf-tablet {
      padding: 0;
      position: relative;
      left: 0;
      top: 0;
      border: none;
    }
  }

  .profile {
    @include bp-mf-tablet {
      left: auto !important;
      right: 0;
      max-width: 230px !important;
      min-height: 260px !important;
      height: auto !important;
    }
  }
</style>
